import { Injectable } from "@angular/core";
import { from, Observable } from "rxjs";
import { mergeMap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class ScriptLoaderService {
	//#region METHODS

	/** Charge une liste de scripts.
	 * @param paScriptSrcs Sources des scripts.
	 */
	public load(paScriptSrcs: string[]): Observable<boolean>;
	/** Charge un script.
	 * @param psScriptSrc Source du script.
	 */
	public load(psScriptSrc: string): Observable<boolean>;
	public load(poData: string | string[]): Observable<boolean> {
		if (poData instanceof Array) return from(poData).pipe(mergeMap((psUrl: string) => this.load(psUrl)));
		else return from(this.loadScript(poData));
	}

	private loadScript(psScriptUrl: string): Promise<boolean> {
		return new Promise((pfResolve: (poValue: boolean | PromiseLike<boolean>) => void) => {
			let script = document.createElement("script");
			script.type = "text/javascript";
			script.src = psScriptUrl;

			script.onload = () => pfResolve(true);
			script.onerror = (poError) => {
				console.warn("SCRIPT.S:: Error during script loading.", psScriptUrl, poError);
				pfResolve(false);
			};
			document.getElementsByTagName("head")[0].appendChild(script);
		});
	}

	//#endregion
}
